<template>
  <div class="share-networks" :class="{ 'share-networks--product': isProduct }">
    <span class="share-networks__title" v-if="!isProduct">Поделиться:</span>
    <ul class="share-networks__list">
      <li v-for="(item, i) in socials" :key="i">
        <ShareNetwork
          :url="currentUrl"
          :network="item.network"
          :title="data.title"
          :description="data.subtitle || data.description"
        >
          <span class="share-networks__item">
            <span :title="item.title">
              <FileIconComponent :name="item.icon" />
            </span>
            <span class="share-networks__item-title" v-show="isProduct">{{ item.title }}</span>
          </span>
        </ShareNetwork>
      </li>
      <li>
        <a @click.prevent="copyUrl" href="#">
          <span class="share-networks__item">
            <span title="Скопировать ссылку">
              <IconComponent v-if="done" name="tick" />
              <IconComponent v-else name="copy" />
            </span>
            <span class="share-networks__item-title" v-show="isProduct">Скопировать ссылку</span>
          </span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import FileIconComponent from "components/FileIconComponent.vue";
import IconComponent from "components/IconComponent.vue";

export default {
  name: "ShareNetworksComponent",
  components: { IconComponent, FileIconComponent },
  props: {
    data: Object,
    isProduct: Boolean,
  },
  data() {
    return {
      done: false,
      socials: [
        {
          title: "ВКонтакте",
          network: "vk",
          icon: "vk",
        },
        // {
        //   title: "Одноклассники",
        //   network: "odnoklassniki",
        //   icon: "ok",
        // },
        {
          title: "Twitter",
          network: "twitter",
          icon: "twitter",
        },
        {
          title: "Whatsapp",
          network: "whatsapp",
          icon: "whatsapp",
        },
        {
          title: "Telegram",
          network: "telegram",
          icon: "telegram",
        },
      ],
    };
  },
  computed: {
    currentUrl() {
      return this.$store.state._env.MEDIA_ENDPOINT + this.$route.fullPath;
    },
  },
  methods: {
    async copyUrl() {
      try {
        await navigator.clipboard.writeText(location.href);
      } catch (err) {
        let inp = document.createElement("input");
        inp.value = location.href;
        document.body.appendChild(inp);
        inp.select();
        document.execCommand("copy");
        document.body.removeChild(inp);
      }
    },
  },
};
</script>

<style lang="stylus">
.share-networks {
  display flex
  align-items center
  justify-content center
  margin 0 auto
  gap: 5px

  &__title {
    display flex
  }

  &--product &__list {
    display flex
    flex-direction column
  }

  &__list {
    display flex
    flex-direction row
    gap: 5px

    li {
      display flex
      align-items center

      a {
        width 100%
      }
    }
  }

  &__item {
    display flex
    align-items center
    gap: 5px

    &:hover {
      .file-icon svg path {
        fill var(--main-color-75)
      }
    }

    > span {
      display flex
      white-space nowrap
      flex-shrink 0
    }

    .icon,
    .file-icon {
      width: 22px
      height: 22px
    }

    .file-icon {
      svg path {
        fill var(--dark)
        transition var(--transition)
      }
    }
  }
}
</style>
